export const API_ENCRYPTION_MODES = {
    NONE: "NONE",
    BASE64: "BASE64",
    PKI: "PKI",
}

export const DEFAULT_API_ENCRYPTION = API_ENCRYPTION_MODES.PKI
